export class AddNewDataModel {
    id: number;
    name: string;
    description: string;
    isActive: boolean;
}
